import { animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';

@UntilDestroy()
@Component({
  selector: 'app-dashboard-listing',
  templateUrl: './dashboard-listing.component.html',
  styleUrls: ['./dashboard-listing.component.css']
})
export class DashboardListingComponent implements OnInit {
  @Input() companyId:any; 
  search: string = '';
  currentPage: number = 1;
  totalResults: number = 0;
  filteredDriverList: any[] = [];
  totalPages: number = 0;
  numberOfRecords: number = 50; 
  dashboardData: any;
  driverCount: number = 0;
  vehicleCount: number = 0;
  thresholdData: any;
  todayDate: string = moment().toISOString(); // Default to today's date
  preSpacetypes:any = {};


  constructor(private CredentialService: CredentialService,
    private configurationService: ConfigurationService,
    private spaceTypeService: SpaceTypeService
  ) { }

  ngOnInit(): void {
    this.getDashboardDetail(this.currentPage);
    this.getDashboard();
    this.getSpaceType();
  }

  getDashboardDetail(page:any) {
    const queryParams = {
      page,
      time: moment(this.todayDate).startOf('day').toISOString()
    }
    this.CredentialService.getDashboardThresholds(this.companyId,queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.dashboardData = data.results;
      }
    })
  }

    getSpaceType() {
      const queryparams = {
        limit: 9999,
        isActive: true
      }
    this.spaceTypeService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preSpacetypes = data.results.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  

  onDateChange(event:any) {
    this.todayDate = event.toISOString();
    this.getDashboardDetail(this.currentPage);
  }
  

  getDashboard() {
    this.configurationService.getDashboardDetails(this.companyId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
       this.driverCount = data.drivers;
       this.vehicleCount = data.vehicles;

      }
    })
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    // Logic to fetch new data based on the current page
  }

  onSelectStatus(event: any): void {
    const status = event.target.value;
    // Logic to filter based on status
  }

}
